import React from 'react';
import ServiceTemplate from './ServiceTemplate';
import SEOMetaTags from '../../components/SEO/SEOMetaTags';
import { useTranslation } from '../../hooks/useTranslation';

import technologySoftwareAgency from '../../assets/images/tech/technology-software-agency.png';
import mateuszRecognition from '../../assets/images/team/Mateusz-recognition.png';

const SoftwareAgencyPage: React.FC = () => {
    const { t, tJsx } = useTranslation();

    const industryCards = [
        {
            text: t("softwareAgency.industry.card1"),
        },
        {
            text: t("softwareAgency.industry.card2"),
        },
        {
            text: t("softwareAgency.industry.card3"),
        }
    ];

    const softwareAgencyCards = [
        {
            title: t("softwareAgency.cards.title1"),
            description: t("softwareAgency.cards.description1")
        },
        {
            title: t("softwareAgency.cards.title2"),
            description: t("softwareAgency.cards.description2")
        },
        {
            title: t("softwareAgency.cards.title3"),
            description: t("softwareAgency.cards.description3")
        }
    ];

    const howWeWorkSteps = [
        {
            title: t("softwareAgency.howWeWork.step1.title"),
            description: [
                t("softwareAgency.howWeWork.step1.description1"),
                t("softwareAgency.howWeWork.step1.description2")
            ],
        },
        {
            title: t("softwareAgency.howWeWork.step2.title"),
            description: [
                t("softwareAgency.howWeWork.step2.description1"),
                t("softwareAgency.howWeWork.step2.description2")
            ],
        },
        {
            title: t("softwareAgency.howWeWork.step3.title"),
            description: [
                t("softwareAgency.howWeWork.step3.description1"),
                t("softwareAgency.howWeWork.step3.description2")
            ],
        },
        {
            title: t("softwareAgency.howWeWork.step4.title"),
            description: [
                t("softwareAgency.howWeWork.step4.description1"),
                t("softwareAgency.howWeWork.step4.description2")
            ],
        }
    ];

    const nextSteps = [
        {
            title: t("softwareAgency.nextSteps.step1")
        },
        {
            title: t("softwareAgency.nextSteps.step2")
        },
        {
            title: t("softwareAgency.nextSteps.step3")
        }
    ];

    const technologies = [
        { name: "technologySoftwareAgency", logo: technologySoftwareAgency },
    ];

    return (
        <>
            <SEOMetaTags
                title={{
                    pl: "Appotype: Software Agency | Dedykowane Aplikacje Web, Mobile, IoT",
                    en: "Appotype: Software Agency | Custom Web, Mobile & IoT Applications"
                }}
                description={{
                    pl: "Appotype: Software Agency tworząca dedykowane aplikacje web, mobile, serwerowe i IoT. Realizujemy nietypowe projekty, dostosowując technologię, by napędzać Twoją wizję biznesową.",
                    en: "Appotype: Software Agency creating custom web, mobile, server & IoT applications. We handle unique projects, tailoring technology to drive your business vision."
                }}
                canonicalUrl="/uslugi/software-agency"
            />
            <ServiceTemplate
                heroTitle={t("softwareAgency.hero.title")}
                heroSubtitle={t("softwareAgency.hero.subtitle")}
                industryTitle={t("softwareAgency.industry.title")}
                industryCards={industryCards}
                howWeWorkTitle={t("softwareAgency.howWeWork.title")}
                howWeWorkSteps={howWeWorkSteps}
                nextSteps={nextSteps}
                technologiesTitle={t("medtech.technologies.title")}
                technologies={technologies}
                recognition={{
                    title: t("softwareAgency.recognition.title"),
                    subtitle: [
                        t("softwareAgency.recognition.subtitle1"),
                        t("softwareAgency.recognition.subtitle2")
                    ],
                    recognitionImage: mateuszRecognition,
                }}
                caseStudyTitle={t("softwareAgency.caseStudy.title")}
                softwareAgencyCards={softwareAgencyCards}
            />
        </>
    );
};

export default SoftwareAgencyPage; 